module.exports = __webpack_public_path__ + "img/info-1.53fc7224.svg";